var logMsg        = ['Debug','Info','Warning','Error','None'];
var logLevelColor = ['#0073e6','#606060 ','#ffcc00','#cc0000','black'];

export var logLevel = {
    Debug: 0,
    Info: 1,
    Warning: 2,
    Error: 3,
    None: 4
};

var level = logLevel.Debug;

// enable debug (displays log message in the javascript console)
export function enableLog(lvl = logLevel.Debug) {
    level = (lvl >= logLevel.Debug && lvl <= logLevel.None) 
            ? lvl 
            : logLevel.None;
}

// enable debug (displays log message in the javascript console)
export function disableLog() {
    level = logLevel.None;
}

// generic log function, use console.log in debug mode
export function log(message, lvl = logLevel.Debug) {
    if (lvl >= logLevel.None || level > lvl) {
        return;
    }

    var m = new Date();
    var dateString =
        m.getUTCFullYear() +"-"+
        ("0" + (m.getUTCMonth()+1)).slice(-2) +"-"+
        ("0" + m.getUTCDate()).slice(-2) + " " +
        ("0" + m.getUTCHours()).slice(-2) + ":" +
        ("0" + m.getUTCMinutes()).slice(-2) + ":" +
        ("0" + m.getUTCSeconds()).slice(-2);

    var color = logLevelColor[lvl];
    console.log("%c " + dateString + " [" + logMsg[lvl].toUpperCase() + "] " + message, "color:" + color + ";");// eslint-disable-line no-console
}

// Return current log level
export function getLogLevel() {
    return level;
}